import { EMAIL_ADD, PHONE, PHONE_NUMBER, OFFICE_HOURS} from './constants'
import { ReactComponent as PhoneIcon } from '../assets/phone.svg';
import { ReactComponent as MailIcon } from '../assets/mail.svg';
import { ReactComponent as ClockIcon } from '../assets/clock.svg';

export default function AboveNav() {

    return(
        <div className="bg-white lg:block sm:hidden">
            <div className="max-w-8xl flex p-3 gap-3 items-center justify-between">
               <div className='flex gap-3'>
                    <div className='flex items-center gap-2'>
                        <PhoneIcon className="w-4 h-4" aria-hidden="true" />
                        <a href={`tel:${PHONE}`} className="text-sm">
                        {PHONE_NUMBER}
                        </a>
                    </div>
                    <div className='items-center'>·</div>
                    <div className='flex items-center gap-2'>
                        <MailIcon className="w-4 h-4" aria-hidden="true" />
                        <a href={`mailto:${EMAIL_ADD}`} className="text-sm">
                        {EMAIL_ADD}
                        </a>
                    </div>
                    <div className='items-center'>·</div>
                    <div className='flex items-center gap-2'>
                        <ClockIcon className="w-4 h-4" aria-hidden="true" />
                        <a href={`mailto:${EMAIL_ADD}`} className="text-sm">
                        {OFFICE_HOURS}
                        </a>
                    </div>
                </div>
                <div>
                    <a
                        href='https://facebook.com/quilatonlawoffice'
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-black lg:text-base sm:text-xs py-5 px-7 hover:text-white hover:bg-black duration-300 ease-in-out font-bold"
                    >f</a>
                    <a
                        href='https://linkedin.com/in/atty-abelardo-quilaton-jr-5a3b25248/'
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-black lg:text-base sm:text-xs py-5 px-7 hover:text-white hover:bg-black duration-300 ease-in-out font-bold"
                    >in</a>
                    <a
                        href='/contact/'
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white bg-black lg:text-base sm:text-xs py-4 px-7 duration-300 ease-in-out font-bold"
                    ><small>BOOK AN APPOINTMENT</small></a>
               </div>
            </div>
        </div>
    )

}